import React from "react";
import CmsBlock from "app/layout/cmsBlock";

export const VerticalSlider = () => {
  return <CmsBlock id={"collection_vertical_slider_v2"} />;
};

export const CollectionSlide1 = () => {
  return <CmsBlock id={"our_collection_slide_1"} />;
};
export const CollectionSlide2 = () => {
  return <CmsBlock id={"our_collection_slide_2"} />;
};
export const CollectionSlide3 = () => {
  return <CmsBlock id={"our_collection_slide_3"} />;
};
